import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export interface UpdateDaypartGlobalComponentItem {
  id?: number;
  component_id: number;
  daypart_id: number;
}
export enum HttpMethod {
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  PUT = 'PUT',
}

export interface UpdateDaypartGlobalComponentsPayload {
  components: UpdateDaypartGlobalComponentItem[];
}

export interface TransactionPayload {
  resource: string;
  method: HttpMethod;
  id?: number;
  data?: Record<string, any>;
}

export const useUpdateDaypartGlobalComponents = () => {
  return useMutation({
    mutationFn: updateDaypartGlobalComponents,
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.dayparts.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.dayparts.all(['globalComponents']),
      );
      queryClient.invalidateQueries(
        queryKeys.daypartGlobalComponent.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.components.invalidateAll());
    },
  });
};

const updateDaypartGlobalComponents = async (payload: TransactionPayload[]) => {
  const response = await requestCCApi({
    url: '/transaction',
    method: HttpMethod.POST,
    data: { data: payload },
  });

  return response;
};
